/**
 * Утилита маски телефона для российских номеров.
 *
 * Форматы:
 *  - визуальный (для input): +7 (XXX) XXX-XX-XX
 *  - нормализованный (для CRM): +7XXXXXXXXXX (E.164 без форматирования)
 *
 * Принцип:
 *  1. Из любого ввода извлекаем 10 цифр (после ведущей 7/8).
 *  2. Накладываем маску только если есть хотя бы 1 цифра.
 *  3. Валидно = ровно 10 цифр (без учёта +7).
 */

/** Извлекает до 10 «национальных» цифр номера, отбрасывая +7/8 в начале. */
export function extractDigits(input: string): string {
  const onlyDigits = input.replace(/\D/g, '');
  // Если первая цифра — 7 или 8, считаем её префиксом и отбрасываем.
  const stripped = onlyDigits.replace(/^[78]/, '');
  return stripped.slice(0, 10);
}

/**
 * Накладывает визуальную маску. Для пустого ввода возвращает пустую строку
 * (не показываем «+7 (» если поле ещё не трогали — лучше плейсхолдер).
 */
export function formatPhone(input: string): string {
  const digits = extractDigits(input);
  if (digits.length === 0) return '';
  const parts: string[] = ['+7 ('];
  parts.push(digits.slice(0, 3));
  if (digits.length >= 3) parts.push(') ');
  if (digits.length >= 4) parts.push(digits.slice(3, 6));
  if (digits.length >= 7) parts.push('-');
  if (digits.length >= 7) parts.push(digits.slice(6, 8));
  if (digits.length >= 9) parts.push('-');
  if (digits.length >= 9) parts.push(digits.slice(8, 10));
  return parts.join('');
}

/** Возвращает E.164 (+7XXXXXXXXXX) или null если номер неполный. */
export function normalizePhone(input: string): string | null {
  const digits = extractDigits(input);
  if (digits.length !== 10) return null;
  return `+7${digits}`;
}

/** Boolean: ввод содержит ровно 10 национальных цифр. */
export function isValidPhone(input: string): boolean {
  return extractDigits(input).length === 10;
}
